import React from "react";
import "./AdDetailsAdTitle.css";

const AdDetailsDescription = ({ title }) => {

    return (
        <div className="item_title">
            <h5 className="item_title_title">{title}</h5>
        </div>
    )
}

export default AdDetailsDescription;